export { default as KeyboardSolidIcon } from './KeyboardSolidIcon';
